import { Typography } from '@material-ui/core'
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'
import { routes } from '@/routes/config'

import { InputItem } from './input-item'
import { useStyles } from './styles'

export function HerbicideTreatments() {
  const classes = useStyles()

  const {
    infestationData,
    previousStep,
    nextStep,
    applyHerbicideTreatmentToLayer,
  } = useCreatePulverizationMap()

  const filteredLayersMap = useMemo(
    () =>
      infestationData?.layersMap.filter(
        (layer) => !layer.removed && !layer.mergedName,
      ),
    [infestationData?.layersMap],
  )

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <header>
          <Typography variant='h3'>
            Definir tratamento com defensivos
          </Typography>
        </header>

        <ul>
          {infestationData?.mergedLayersMap.map((layer) => (
            <InputItem
              key={layer.name}
              name={layer.name}
              herbicideTreatment={layer.herbicideTreatment}
              bgColor={layer.colorPalette}
              border='1px solid #00000033'
              onSelectedHerbicideTreatment={(herbicideTreatment) =>
                applyHerbicideTreatmentToLayer(
                  'mergedLayersMap',
                  layer.name,
                  herbicideTreatment,
                )
              }
            />
          ))}

          {filteredLayersMap?.map((layer) => (
            <InputItem
              key={layer.name}
              name={layer.name}
              herbicideTreatment={layer.herbicideTreatment}
              bgColor={layer.colorPalette}
              onSelectedHerbicideTreatment={(herbicideTreatment) =>
                applyHerbicideTreatmentToLayer(
                  'layersMap',
                  layer.name,
                  herbicideTreatment,
                )
              }
            />
          ))}
        </ul>
      </div>

      <div className={classes.cardInfo}>
        <span className='material-symbols-outlined'>tips_and_updates</span>
        <div>
          <Typography variant='subtitle1'>
            Acompanhe os índices de economia e sustentabilidade ao cadastrar os
            tratamentos na plataforma.
          </Typography>
          <div>
            <Typography variant='subtitle2'>Acessar</Typography>
            <Link
              className={classes.linkInfo}
              target='_blank'
              to={routes.Reports('economy-dashboard')}
            >
              <DashboardOutlinedIcon />
              <Typography variant='subtitle2'>Economia</Typography>
            </Link>
          </div>
        </div>
      </div>

      <div className={classes.buttonContainer}>
        <Button outlined onClick={previousStep}>
          Voltar
        </Button>
        <Button
          onClick={nextStep}
          disabled={infestationData?.layersMap.every((layer) => layer.removed)}
        >
          Avançar
        </Button>
      </div>
    </div>
  )
}
